module.exports = {"id":"198589","name":"Greg Garza","rating":"71","photo":"./data/images/photos/4/198589.png","club":{"name":"Atlanta United FC","logo":"./data/images/clubs/AtlantaUnitedFC.png"},"positions":["DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GregGarza0.json
// module id = 1638
// module chunks = 0